import React, { useEffect, useCallback } from 'react';
import useUsersApi from '../hooks/useUsersApi';
import auth0Client from 'on_web/Auth0';

export default function ResetUserData() {
  const [
    { deleteAllUserData, deletingChainError, deletingChain, logout },
  ] = useUsersApi();

  const redirectUser = useCallback(() => {
    logout();
    auth0Client.signOut();
  }, [logout]);

  useEffect(() => {
    deleteAllUserData();
  }, [deleteAllUserData]);

  useEffect(() => {
    if (deletingChain === false) {
      const timer = setTimeout(redirectUser(), 5000);
      return () => clearTimeout(timer);
    }
  });

  return (
    <div>
      {' '}
      {deletingChain ? (
        <div>Deleting...</div>
      ) : deletingChainError ? (
        <div>Delete failed</div>
      ) : (
        <div>Delete succeeded! You will be redirected in 5s...</div>
      )}
    </div>
  );
}
